import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", p: 3, textAlign: "center" }}>
      <Helmet>
        <title>Page not found | Risk Manager</title>
      </Helmet>
      <Box>
        <Typography sx={{ fontSize: 72, fontWeight: 700, color: "#C3CBD2", lineHeight: 1 }}>404</Typography>
        <Typography variant="h5" sx={{ mt: 2 }}>
          This page can't be found
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1, mb: 3 }}>
          The link may be old, or the page has moved.
        </Typography>
        <Button component={RouterLink} to="/insurance/" variant="contained">
          Go to the dashboard
        </Button>
      </Box>
    </Box>
  );
}
